import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M15.843 8.715A5.82 5.82 0 1 0 4.6 11.728a5.82 5.82 0 0 0 11.243-3.013m-7.49-5.467a7.22 7.22 0 0 1 7.445 11.56l4.997 4.997a.7.7 0 0 1-.99.99L14.81 15.8A7.22 7.22 0 1 1 8.353 3.248"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
